import { types } from '../actions/jobAlerts';

const initialState = {
  pendingFlag: false,
  error: '',
  createPending: false,
  createError: '',
  updatePending: false,
  updateError: '',
  deletePending: false,
  deleteError: '',
  isActive: false,
  alerts: [],
  slice: 2,
  alertsForFilters: [],
  cardStyleFade: false
};

const remoteWork = (alert) => {
  switch (alert?.RemoteWork) {
    case 0:
      return ['0'];
    case 1:
      return ['1'];
    case 2:
      return ['2'];
    default:
      return [];
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_ALL_JOB_ALERTS_PENDING:
      return {
        ...state,
        error: '',
        success: false,
        pendingFlag: true,
        isActive: false,
        alerts: [],
        alertsForFilters: []
      };
    case types.GET_ALL_JOB_ALERTS_REJECTED:
      return {
        ...state,
        success: false,
        error: action.payload?.response?.data,
        pendingFlag: false,
        isActive: false,
        alerts: [],
        alertsForFilters: []
      };
    case types.GET_ALL_JOB_ALERTS_FULFILLED:
      return {
        ...state,
        error: '',
        success: true,
        pendingFlag: false,
        isActive: action?.payload?.Data.isActive,
        alerts: action?.payload?.Data?.jobAlerts,
        alertsForFilters: action?.payload?.Data?.jobAlerts?.length
          ? [
              ...action.payload.Data.jobAlerts.map((alert) => ({
                city: alert?.City,
                contractTypes: alert?.JobAlertContractTypes.map((contracts) => contracts.JobType),
                country: alert?.Country,
                functions: alert?.JobAlertJobFunctions.map((functions) => functions.JobFunction.Name),
                industries: alert?.JobAlertIndustries.map((industry) => industry.Industry.Name),
                location: alert?.Location,
                remoteTypes: remoteWork(alert),
                searchTxt: alert?.Keyword,
                state: alert?.State
              }))
            ]
          : []
      };
    case types.CREATE_NEW_JOB_ALERT_PENDING:
      return {
        ...state,
        createError: '',
        createPending: true,
        alerts: [...state.alerts],
        alertsForFilters: [...state.alerts]
      };
    case types.CREATE_NEW_JOB_ALERT_REJECTED:
      return {
        ...state,
        createError: action.payload?.response?.data,
        createPending: false,
        alerts: [...state.alerts],
        alertsForFilters: [...state.alerts]
      };
    case types.CREATE_NEW_JOB_ALERT_FULFILLED:
      return {
        ...state,
        createError: '',
        createPending: false,
        alerts: [...state.alerts, action?.payload],
        alertsForFilters: action?.payload
          ? [
              ...state.alerts,
              {
                city: action.payload?.City,
                contractTypes: action.payload?.JobAlertContractTypes?.map((contracts) => contracts.JobType),
                country: action.payload?.Country,
                functions: action.payload?.JobAlertJobFunctions?.map((functions) => functions.JobFunction.Name),
                industries: action.payload?.JobAlertIndustries?.map((industry) => industry.Industry.Name),
                location: action.payload?.Location,
                remoteTypes: remoteWork(action.payload),
                searchTxt: action.payload?.Keyword,
                state: action.payload?.State
              }
            ]
          : [...state.alerts]
      };
    case types.EDIT_JOB_ALERT_PENDING:
      return {
        ...state,
        updateError: '',
        updatePending: true
      };
    case types.EDIT_JOB_ALERT_REJECTED:
      return {
        ...state,
        updateError: action.payload?.response?.data,
        updatePending: false
      };
    case types.EDIT_JOB_ALERT_FULFILLED:
      return {
        ...state,
        updateError: '',
        updatePending: false,
        alerts: state.alerts.map((alert) => (alert.Id === action.payload?.Id ? action.payload : alert))
      };
    case types.DELETE_JOB_ALERT_PENDING:
      return {
        ...state,
        deleteError: '',
        deletePending: true
      };
    case types.DELETE_JOB_ALERT_REJECTED:
      return {
        ...state,
        deleteError:
          action.payload?.response.status !== 500
            ? action.payload?.response?.data?.message
            : action.payload?.response?.data,
        deletePending: false
      };
    case types.DELETE_JOB_ALERT_FULFILLED:
      return {
        ...state,
        deleteError: '',
        deletePending: false,
        alerts: state.alerts.filter((alert) => alert.Id !== action.payload)
      };
    case types.SHOW_ALL:
      return {
        ...state,
        slice: action.payload
      };
    case types.UNSUBSCRIBE_JOB_ALERT_PENDING:
      return {
        ...state,
        error: '',
        unsubscribePending: true,
        isActive: null
      };
    case types.UNSUBSCRIBE_JOB_ALERT_FULFILLED:
      return {
        ...state,
        error: '',
        unsubscribePending: false,
        isActive: action?.payload?.Data?.isActive
      };
    case types.REVERT_DELETED_ALERT_PENDING:
      return {
        ...state,
        deletePending: true
      };
    case types.REVERT_DELETED_ALERT_REJECTED:
      return {
        ...state,
        deletePending: false
      };
    case types.REVERT_DELETED_ALERT_FULFILLED:
      return {
        ...state,
        deletePending: false,
        alerts: [action?.payload, ...state.alerts]
      };
    case types.CARD_STYLE:
      return {
        ...state,
        cardStyleFade: action.payload
      };
    default:
      return state;
  }
}
